import type { AreaGroupId, Coordinates, RegionId } from "./schema";

export interface AreaGroupDefinition {
  id: AreaGroupId;
  name: string;
  description: string;
}

export interface RegionDefinition {
  id: RegionId;
  name: string;
  shortName: string;
  areaGroup: AreaGroupId;
  center: Coordinates;
}

export const areaGroups: AreaGroupDefinition[] = [
  { id: "capital", name: "수도권", description: "서울·경기·인천" },
  { id: "gangwon", name: "강원권", description: "강원" },
  { id: "chungcheong", name: "충청권", description: "대전·세종·충북·충남" },
  { id: "honam", name: "호남권", description: "광주·전북·전남" },
  { id: "daegyeong", name: "대경권", description: "대구·경북" },
  { id: "southeast", name: "동남권", description: "부산·울산·경남" },
  { id: "jeju", name: "제주권", description: "제주" },
];

export const regions: RegionDefinition[] = [
  { id: "seoul", name: "서울특별시", shortName: "서울", areaGroup: "capital", center: { lat: 37.5665, lng: 126.978 } },
  { id: "incheon", name: "인천광역시", shortName: "인천", areaGroup: "capital", center: { lat: 37.4563, lng: 126.7052 } },
  { id: "gyeonggi", name: "경기도", shortName: "경기", areaGroup: "capital", center: { lat: 37.4138, lng: 127.5183 } },
  { id: "gangwon", name: "강원특별자치도", shortName: "강원", areaGroup: "gangwon", center: { lat: 37.8228, lng: 128.1555 } },
  { id: "daejeon", name: "대전광역시", shortName: "대전", areaGroup: "chungcheong", center: { lat: 36.3504, lng: 127.3845 } },
  { id: "sejong", name: "세종특별자치시", shortName: "세종", areaGroup: "chungcheong", center: { lat: 36.48, lng: 127.289 } },
  { id: "chungbuk", name: "충청북도", shortName: "충북", areaGroup: "chungcheong", center: { lat: 36.6357, lng: 127.4917 } },
  { id: "chungnam", name: "충청남도", shortName: "충남", areaGroup: "chungcheong", center: { lat: 36.6588, lng: 126.6728 } },
  { id: "gwangju", name: "광주광역시", shortName: "광주", areaGroup: "honam", center: { lat: 35.1595, lng: 126.8526 } },
  { id: "jeonbuk", name: "전북특별자치도", shortName: "전북", areaGroup: "honam", center: { lat: 35.8203, lng: 127.1088 } },
  { id: "jeonnam", name: "전라남도", shortName: "전남", areaGroup: "honam", center: { lat: 34.8679, lng: 126.991 } },
  { id: "daegu", name: "대구광역시", shortName: "대구", areaGroup: "daegyeong", center: { lat: 35.8714, lng: 128.6014 } },
  { id: "gyeongbuk", name: "경상북도", shortName: "경북", areaGroup: "daegyeong", center: { lat: 36.4919, lng: 128.8889 } },
  { id: "busan", name: "부산광역시", shortName: "부산", areaGroup: "southeast", center: { lat: 35.1796, lng: 129.0756 } },
  { id: "ulsan", name: "울산광역시", shortName: "울산", areaGroup: "southeast", center: { lat: 35.5384, lng: 129.3114 } },
  { id: "gyeongnam", name: "경상남도", shortName: "경남", areaGroup: "southeast", center: { lat: 35.4606, lng: 128.2132 } },
  { id: "jeju", name: "제주특별자치도", shortName: "제주", areaGroup: "jeju", center: { lat: 33.4996, lng: 126.5312 } },
];

export const areaGroupById = Object.fromEntries(
  areaGroups.map((areaGroup) => [areaGroup.id, areaGroup]),
) as Record<AreaGroupId, AreaGroupDefinition>;

export const regionById = Object.fromEntries(
  regions.map((region) => [region.id, region]),
) as Record<RegionId, RegionDefinition>;
